import React from "react";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import localeData from "dayjs/plugin/localeData";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from "@mui/x-date-pickers";

import Loading from "./components/layout/Loading";
import theme from "./theme/main";
import store from "./store/store";
import App from "./App";

// dayjs plugins/locale are loaded once, globally, here — every other file
// just `import dayjs from "dayjs"` and uses it. Adding a dayjs feature that
// needs a plugin (e.g. isSameOrAfter, relativeTime)? Extend it here, not
// per-file, or it silently won't be available where you use it.
require('dayjs/locale/pt');
dayjs.extend(isBetween);
dayjs.extend(localeData);
dayjs.locale("pt");

const appRoot = createRoot(document.getElementById("root"));

appRoot.render(
    <React.Suspense fallback={<Loading />}>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <App />
                </LocalizationProvider>
                <Loading />
            </ThemeProvider>
        </Provider>
    </React.Suspense>
);
